import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { LaunchHostingState } from './types'

export const initialState: LaunchHostingState = {
  launchHostingLoading: false,
  launchHostingError: undefined
}

export const slice = createSlice({
  name: 'launchHosting',
  initialState,
  reducers: {
    launchHosting: state => {
      state.launchHostingError = undefined
      state.launchHostingLoading = true
    },
    launchHostingSuccess: state => {
      state.launchHostingLoading = false
      state.launchHostingError = undefined
    },
    launchHostingFailure: (state, action: PayloadAction<string>) => {
      state.launchHostingLoading = false
      state.launchHostingError = action.payload
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
